import { render } from "./NewContractParams.vue?vue&type=template&id=a0d6f594"
import script from "./NewContractParams.vue?vue&type=script&lang=js"
export * from "./NewContractParams.vue?vue&type=script&lang=js"

import "./NewContractParams.vue?vue&type=style&index=0&id=a0d6f594&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__